export default {
  get () {
    return [
      {
        title: 'Greedy for doughnuts',
        thumb: './thumbs/WebDonut_Greed.jpg',
        images: [
          './works/WebDonut_Greed1.jpg',
          './works/WebDonut_Greed2.jpg'
        ]
      },
      {
        title: 'Candy love',
        thumb: './thumbs/WebCandyLove.jpg',
        images: [
          './works/WebCandyLove1.jpg',
          './works/WebCandyLove2.jpg'
        ]
      },
      {
        title: 'Chickadee, chickadee, chickadee, finch',
        thumb: './thumbs/mesmesmes.jpg',
        images: [
          './works/mesmesmes1.jpg',
          './works/mesmesmes2.jpg',
          './works/mesmesmes3.jpg'
        ]
      },
      {
        title: 'Skyscrapes-Project JOAN',
        thumb: './thumbs/skyscrape.jpg',
        images: [
          './works/skyscrape1.jpg',
          './works/skyscrape2.jpg',
          './works/skyscrape3.jpg'
        ]
      },
      {
        title: 'Tiny Things 2',
        thumb: './thumbs/smasak2.jpg',
        images: [
          './works/smasak21.jpg',
          './works/smasak22.jpg',
          './works/smasak23.jpg'
        ]
      },
      {
        title: 'Bang Bang Bang',
        thumb: './thumbs/reforma.jpg',
        images: [
          './works/reforma1.jpg',
          './works/reforma2.jpg',
          './works/reforma3.jpg',
          './works/reforma4.jpg',
          './works/reforma5.jpg',
          './works/reforma6.jpg',
          './works/reforma7.jpg',
          './works/reforma8.jpg',
          './works/reforma9.jpg',
          './works/reforma10.jpg',
          './works/reforma11.jpg',
          './works/reforma12.jpg',
          './works/reforma13.jpg',
          './works/reforma14.jpg',
          './works/reforma15.jpg'
        ]
      },
      {
        title: 'Woods',
        thumb: './thumbs/dunge.jpg',
        images: [
          './works/dunge1.jpg',
          './works/dunge2.jpg',
          './works/dunge3.jpg'
        ]
      },
      {
        title: 'A fox behind the ear',
        thumb: './thumbs/lund.jpg',
        images: [
          './works/lund1.jpg',
          './works/lund2.jpg',
          './works/lund3.jpg',
          './works/lund4.jpg',
          './works/lund5.jpg',
          './works/lund6.jpg',
          './works/lund7.jpg',
          './works/lund8.jpg',
          './works/lund9.jpg',
          './works/lund10.jpg',
          './works/lund11.jpg'
        ]
      },
      {
        title: 'Tiny things: 2008',
        thumb: './thumbs/smasak.jpg',
        images: [
          './works/smasak1.jpg',
          './works/smasak2.jpg',
          './works/smasak3.jpg',
          './works/smasak4.jpg',
          './works/smasak5.jpg',
          './works/smasak6.jpg',
          './works/smasak7.jpg',
          './works/smasak8.jpg',
          './works/smasak9.jpg',
          './works/smasak10.jpg'
        ]
      },
      {
        title: 'Leg hooks: 2007',
        thumb: './thumbs/krokben.jpg',
        images: [
          './works/krokben1.jpg',
          './works/krokben2.jpg',
          './works/krokben3.jpg'
        ]
      },
      {
        title: 'Trophys: 2007',
        thumb: './thumbs/trophy.jpg',
        images: [
          './works/trophy1.jpg',
          './works/trophy2.jpg',
          './works/trophy3.jpg'
        ]
      },
      {
        title: 'Contacts: 2006',
        thumb: './thumbs/kontakter.jpg',
        images: [
          './works/kontakter1.jpg',
          './works/kontakter2.jpg',
          './works/kontakter3.jpg',
          './works/kontakter4.jpg',
          './works/kontakter5.jpg',
          './works/kontakter6.jpg'
        ]
      },
      {
        title: 'Rose Necklace: 2006',
        thumb: './thumbs/halsband.jpg',
        images: [
          './works/halsband1.jpg',
          './works/halsband2.jpg'
        ]
      },
      {
        title: 'Pillows: 2006',
        thumb: './thumbs/kuddar.jpg',
        images: [
          './works/kuddar1.jpg',
          './works/kuddar2.jpg',
          './works/kuddar3.jpg',
          './works/kuddar4.jpg'
        ]
      },
      {
        title: 'Ladies 2005',
        thumb: './thumbs/byster.jpg',
        images: [
          './works/byster1.jpg',
          './works/byster2.jpg'
        ]
      },
      {
        title: 'White measures 2006',
        thumb: './thumbs/atgard.jpg',
        images: [
          './works/atgard1.jpg',
          './works/atgard2.jpg',
          './works/atgard3.jpg',
          './works/atgard4.jpg',
          './works/atgard5.jpg'
        ]
      },
      {
        title: 'Body boxes: 2004',
        thumb: './thumbs/askar.jpg',
        images: [
          './works/askar1.jpg',
          './works/askar2.jpg',
          './works/askar3.jpg'
        ]
      },
      {
        title: 'Installation: 2001',
        thumb: './thumbs/install.jpg',
        images: [
          './works/install1.jpg',
          './works/install2.jpg',
          './works/install3.jpg'
        ]
      },
      {
        title: 'Centrepiece: 2001',
        thumb: './thumbs/huvudlos.jpg',
        images: [
          './works/huvudlos1.jpg',
          './works/huvudlos2.jpg',
          './works/huvudlos3.jpg',
          './works/huvudlos4.jpg',
          './works/huvudlos5.jpg'
        ]
      },
      {
        title: 'Clouds: 2001',
        thumb: './thumbs/molnfar.jpg',
        images: [
          './works/molnfar1.jpg',
          './works/molnfar2.jpg'
        ]
      },
      {
        title: 'Marzipan Laura: 2001',
        thumb: './thumbs/marsipan.jpg',
        images: [
          './works/marsipan1.jpg'
        ]
      },
      {
        title: 'Boobs: 2001',
        thumb: './thumbs/boobs.jpg',
        images: [
          './works/boobs1.jpg',
          './works/boobs2.jpg',
          './works/boobs3.jpg'
        ]
      }
    ]
  }
}
